module.exports = __webpack_public_path__ + "f9859eda03c0e1af12e148ed2a194e72.svg";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/opensans-regular-webfont.svg
// module id = 71
// module chunks = 0